<template>
  <ux-form
        ref="formRef"
        :messages="{ required: field => {
          const temp = field.replace('：','')
          return `请输入${temp}的值`
        } }"
        layout="horizontal"
      >
        <ux-form-item :class="{'view-info': modal === 'view'}" label="需求名称：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <ux-field-decorator name="serverName" :rules="[{required:true}, {max:20, message: '需求名称不能大于20个字符'}]">
            <ux-input v-if="modal === 'add'" v-model="form.serverName" />
            <span v-else>{{ form.serverName }}</span>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item :class="{'view-info': modal === 'view'}" label="需求类型：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <ux-field-decorator name="categoryThirCode" rules="required">
            <ux-select v-if="modal === 'add'" v-model="form.categoryThirCode" style="width: 200px;">
              <ux-option
                v-for="(option, i) in categoryThirCodeOpt"
                :key="i"
                :value="option.value"
                :label="option.label"
              />
            </ux-select>
            <span v-else>{{ requireTypeCode4Label[form.categoryThirCode] }}</span>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item :class="{'view-info': modal === 'view'}" label="招标类型：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <ux-field-decorator name="customizedType" rules="required">
            <ux-select v-if="modal === 'add'" v-model="form.customizedType" style="width: 200px;" placeholder="请选择招标类型">
              <ux-option
                v-for="(option, i) in customizedTypeOpt"
                :key="i"
                :value="option.value"
                :label="option.label"
              />
            </ux-select>
            <span v-else>{{ customizedType4label[form.customizedType] }}</span>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item :class="{'view-info': modal === 'view'}" label="初步预算金额：" :wrapper-col="wrapperCol" :label-col="labelCol" :required="true">
          <ux-row v-if="modal === 'add'">
            <ux-col :span="11">
              <ux-field-decorator class="budget-wrapper" name="minBudget" rules="vaildBudget|required">
                <ux-input v-model="form.minBudget" placeholder="最小金额" />
              </ux-field-decorator>
            </ux-col>
            <ux-col :span="2" style="text-align: center;">
              <span class="budgetText">至</span>
            </ux-col>
            <ux-col :span="11">
              <ux-field-decorator class="budget-wrapper" name="maxnBudget" rules="vaildMaxBudget|required">
                <ux-input v-model="form.maxBudget" placeholder="最大金额" />
              </ux-field-decorator>
            </ux-col>
          </ux-row>
          <span v-else>{{ form.minBudget }} 至 {{ form.maxBudget }}</span>
        </ux-form-item>
        <ux-form-item v-if="divisionAccount && modal === 'add'" :class="{'view-info': modal === 'view'}" label="是否加签审核：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <ux-field-decorator name="signatureSign" rules="required">
            <ux-radio-group v-model="form.signatureSign" :disabled="mustSignature">
              <ux-radio value="1">
              是
              </ux-radio>
              <ux-radio value="0">
              否
              </ux-radio>
            </ux-radio-group>
            <span>备注：预算金额大于10万，默认加签审核，邀请服务商不少于3家</span>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item v-if="form.customizedType == '3' && modal === 'add'" :class="{'view-info': modal === 'view'}" label="邀请服务商名称：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <div v-for="(item, index) in form.fwsArr" :key="index">
            <ux-field-decorator :name="`providerArr${index}`" rules="required">
              <ux-select v-model="item.value" style="width: 200px;" show-search :filter-option="myFilter" placeholder="请选择服务商">
                <ux-option
                  v-for="(option, i) in providerOpt"
                  :key="i"
                  :value="option.value"
                  :label="option.label"
                />
                </ux-select>
                <span class="ml-10 operation" @click="addFws">添加</span>
                <span v-if="index !== 0" class="ml-10 operation" @click="delFws(index)">删除</span>
            </ux-field-decorator>
          </div>
        </ux-form-item>
        <ux-form-item v-if="form.customizedType == '3' && modal === 'view'" :class="{'view-info': modal === 'view'}" label="邀请服务商名称：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <div v-for="(item, index) in targetIsv" :key="index">
            {{ item }}
          </div>
        </ux-form-item>
        <ux-form-item v-if="form.customizedType === '2' && modal === 'add'" :class="{'view-info': modal === 'view'}" label="报名服务商数量：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <ux-field-decorator name="applyNumber" rules="required">
            <ux-select v-model="form.applyNumber" style="width: 200px;" placeholder="请选择报名服务商数量">
              <ux-option
                v-for="(option, i) in applyNumberOpt"
                :key="i"
                :value="option.value"
                :label="option.label"
              />
            </ux-select>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item :class="{'view-info': modal === 'view'}" label="报名截止日期：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <ux-field-decorator name="deadlineDate" rules="required">
            <ux-date-picker v-if="modal === 'add' || changeTime" v-model="form.deadlineDate" />
            <span v-else>{{ form.deadlineDate }}</span>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item :class="{'view-info': modal === 'view'}" label="计划上线日期：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <ux-field-decorator name="deliverDate" rules="required">
            <ux-date-picker v-if="modal === 'add'" v-model="form.deliverDate" />
            <span v-else>{{ form.deliverDate }}</span>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item :class="{'view-info': modal === 'view'}" label="联系人：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <ux-field-decorator name="contactName" :rules="[{required:true, message: '请输入联系人'}, {max:20, message: '联系人不能超过20个字符'}]">
            <ux-input v-if="modal === 'add'" v-model="form.contactName" />
            <span v-else>{{ form.contactName }}</span>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item :class="{'view-info': modal === 'view'}" label="联系方式：" :wrapper-col="wrapperCol" :label-col="labelCol" :required="true">
          <ux-field-decorator name="contactPhone" :rules="[{ required:true, message:'请输入11位手机号' }, { digits:11,message: '请输入11位手机号' }]">
            <ux-input v-if="modal === 'add'" v-model="form.contactPhone" />
            <span v-else>{{ form.contactPhone }}</span>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item :class="{'view-info': modal === 'view'}" label="需求描述：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <ux-field-decorator name="description" :rules="[{required: true, message: '请输入需求描述'},{max:300, message:'需求描述不能超过300个字符'}]">
            <ux-textarea v-if="modal === 'add'" v-model="form.description" />
            <span v-else>{{ form.description }}</span>
          </ux-field-decorator>
        </ux-form-item>
        <ux-form-item :class="{'view-info': modal === 'view'}" label="附件：" :wrapper-col="wrapperCol" :label-col="labelCol">
          <div v-if="modal === 'add'">
            <ux-upload 
                      v-model="fileList"
                      :disabled="fileList.length > 0"
                      :custom-request="customRequest"
                      :before-upload="beforeUpload"
                      accept=".zip,.rar,.7z"
                      @change="uploadChange"
>                     
              <ux-button icon="upload">
                点击上传
              </ux-button>
              <span style="margin-left:8px" @click.stop>上传文件数量限制1个，单个文件大小不超过10M，文件格式仅支持压缩包；</span>
            </ux-upload>
          </div>
          <div v-if="modal === 'add'">
            <!-- <ux-checkbox v-model="agree">
              同意<span class="protcol">苏宁服务市场定制需求服务协议</span>
            </ux-checkbox> -->
          </div>
          <div v-else>
            <a v-if="form.taskEnclosureUrl" @click="downloadZip(form.taskEnclosureUrl)">下载附件</a>
          </div>
        </ux-form-item>
        <ux-form-item v-if="modal === 'add'" :wrapper-col="{ offset: 4 }">
          <ux-button type="primary" :disabled="isLoading" @click="submit">
            提交
          </ux-button>
        </ux-form-item>
      </ux-form>
</template>

<script>
import axios from 'axios';
import { UxForm } from '@cloud-sn/uxcool';
import UxMessage from '@cloud-sn/uxcool/es/message';
import { requireTypeCode4Label, customizedType4label } from './config';

export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    categoryThirCodeOpt: {
      type: Array,
      default: () => []
    },
    customizedTypeOpt: {
      type: Array,
      default: () => []
    },
    providerOpt: {
      type: Array,
      default: () => []
    },
    applyNumberOpt: {
      type: Array,
      default: () => []
    },
    divisionAccount: {
      type: Boolean,
      default: false
    },
    modal: {
      type: String,
      default: 'add'
    },
    changeTime: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [],
      // providerOpt: [],
      labelCol: { sm: 4 },
      wrapperCol: { sm: 11 },
      agree: false,
      requireTypeCode4Label: requireTypeCode4Label,
      customizedType4label: customizedType4label,
      mustSignature: false
    }
  },
  computed: {
    targetIsv() {
      let temp = [];
      if(this.form.isvNames) {
        temp =  this.form.isvNames.split(',');
      }
      return temp
    }
  },
  watch: {
    'form': {
      handler(newValue) {
        if(Number(newValue.maxBudget) >= 100000 && this.divisionAccount) {
          this.form.signatureSign = '1'
          this.mustSignature = true
        } else {
          this.mustSignature = false
        }
      },
      deep: true
    }
  },
  created() {
    const self = this;
    UxForm.extendValidator('vaildBudget', {
      validate(value) {
        let flag = true;
        if(value === '') {
          flag = false;
        }
        if(!/^\d+(\.\d{0,2})?$/.test(Number(value))) {
          flag = false;
        }
        if(self.form.maxBudget !== '' && Number(value) > Number(self.form.maxBudget)) {
          flag = false;
        }
        return flag;
      },
      getMessage(field) {
        return '请输入最多两位小数的数字，且最小金额不大于最大金额';
      },
    });
    UxForm.extendValidator('vaildMaxBudget', {
      validate(value) {
        let flag = true;
        if(value === '') {
          flag = false;
        }
        if(!/^\d+(\.\d{0,2})?$/.test(Number(value))) {
          flag = false;
        }
        if(self.form.minBudget !== '' && Number(value) < Number(self.form.minBudget)) {
          flag = false;
        }
        return flag;
      },
      getMessage(field) {
        return '请输入最多两位小数的数字，且最小金额不大于最大金额';
      },
    });
  },
  methods: {
    myFilter(searchVal, option) {
      if (option.label.indexOf(searchVal) !== -1) return true;
    },
    customRequest(options) {
      const formData = new FormData();
      formData.append("attachment", options.file);
      formData.append("fileName", options.file.name);
      console.log(formData);
      axios.post('/fuwu/ajax/customTask/uploadFile.action', formData).then((res) => {
        console.log(res);
        if(res.data.errCode === '0000' && res.data && res.data.data) {
          UxMessage.success('文件上传成功');
          this.form.taskEnclosureUrl = res.data.data;
          this.fileList = [];
          this.fileList.push(options.file);
        } else {
          const errMsg = res.data.errMsg || '文件上传失败'
          UxMessage.error(errMsg);
        }
      }, () => {
        UxMessage.error('文件上传失败');
      })
    },
    submit() {
      const {
        $refs: { formRef },
      } = this;
      if(formRef) {
        formRef.validate().then(({ valid, values }) => {
          if (!valid) {
            return;
          }
          console.log(Number(this.form.applyNumber));
          const selectedFwsCount = this.form.customizedType === '2' ? Number(this.form.applyNumber) : this.form.fwsArr.length
          if(Number(this.form.maxBudget) > 100000 && 
            selectedFwsCount < 3 && 
            this.divisionAccount
            ) {
            UxMessage.error('最大金额超过10W，邀请服务商数量不小于3');
            return;
          }
          this.$emit('dataChange', this.form)
        });
      }
      
    },
    beforeUpload(file) {
      const { type, size } = file;
      console.log(type);
      const isLt10M = size / 1024 / 1024 <= 10;
      if(!isLt10M) {
        UxMessage.error('文件大小不能超过10M')
        return false;
      }
    },
    uploadChange({ file, fileList}) {
      this.fileList = []
      console.log(file, fileList);
      if(file.status === 'success') {
        this.fileList = fileList;
        // const url = file.response.data || '';
        // this.form.taskEnclosureUrl = url;
      }
      if(file.status === 'removed') {
         this.fileList = [];
         this.form.taskEnclosureUrl = '';
      }
    },
    addFws() {
      this.form.fwsArr.push({
        value: ''
      })
    },
    delFws(index) {
      this.form.fwsArr.splice(index, 1)
    },
    downloadZip(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style scope>
.operation {
  color: #4285F4;
  cursor: pointer;
}
.protcol {
  color: #4285F4;
  cursor: pointer;
}
.view-info {
  margin-bottom: 0px;
}
.view-info label {
  color: #666666;
}
</style>